import {BASE_URL, endPoints} from './urls';
import {UserRegType, VerificationCodeType} from '../interface';
import fetchClient from './index';
export const customSignin = async (data: UserRegType) => {
  try {
    const response = await fetchClient().post(`${BASE_URL}${endPoints.CUSTOMSIGNIN}`, data);
    return response;
  } catch (error) {
    return {error};
  }
};

export const tryRemaning = async (email: any) => {
  try {
    const response = await fetchClient().get(
      `${BASE_URL}${endPoints.USER_VERIFICATION_CODE}?email=${encodeURIComponent(email)}`
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const otpVerification = async (data: VerificationCodeType) => {
  try {
    const response = await fetchClient().post(`${BASE_URL}${endPoints?.VERIFICATION_CODE}`, data);
    return response;
  } catch (error) {
    return {error};
  }
};

export const resetOtp = async (data: any) => {
  try {
    const response = await fetchClient().post(
      `${BASE_URL}${endPoints.USER_VERIFICATION_CODE}`,
      data
    );
    return response;
  } catch (error) {
    return {error};
  }
};
